import { createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('accessControls');

export const GET_ACCESS_CONTROLS = apiType('GetAccessControls');
